/* eslint max-classes-per-file: 0 */

import { CollectorPublication as Data } from '@/typings/api/CollectorPublication'
import { AxiosRequestConfig } from 'axios'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class CollectorKimsTasksApi extends BaseCollectorApiAuth<Data> {
  protected readonly endpoint = '/kims_tasks';

  public generateKims(publication_id: Data['publication_id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = '/generate_kims'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('publication_id', publication_id.toString())
    return this.request('POST', url, { data, params, ...config })
  }
}
